import axios from 'axios'
import {
  CognitoUserPool,
  CookieStorage
} from 'amazon-cognito-identity-js'
import store from '@/store'

export default {
  data () {
    return {

    }
  },
  methods: {
    getAvatarColor () {
      const colors = [
        'red',
        'yellow',
        'green',
        'blue',
        'indigo',
        'purple',
        'pink'
      ]
      return colors[Math.floor(Math.random() * colors.length)]
    },
    stringToColour (str) {
      let hash = 0
      for (let i = 0; i < str.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash)
      }
      let colour = '#'
      for (let i = 0; i < 3; i++) {
        const value = (hash >> (i * 8)) & 0xFF
        colour += ('00' + value.toString(16)).substr(-2)
      }
      return colour
    },
    redirectToAts (token) {
      window.location.href = `${process.env.VUE_APP_HIREFUL_APP_HOST}/#/login/token/${token}`
    },
    async validateSession (to) {
      const withCredentialsConfig = {
        method: 'POST',
        withCredentials: true
      }
      try {
        const sessionResp = await axios(`${process.env.VUE_APP_LOGIN_API_HOST}${store.state.routes.validateSession}`, withCredentialsConfig)
        if (sessionResp.status === 200 && sessionResp.data) {
          if (to.name !== 'switchAccount' && !to.path.startswith('/access_token')) {
            window.location.href = `${process.env.VUE_APP_HIREFUL_APP_HOST}`
          }
        }
      } catch (error) {
        const poolData = {
          UserPoolId: process.env.VUE_APP_COGNITO_USER_POOL_ID,
          ClientId: process.env.VUE_APP_COGNITO_CLIENT_ID,
          Storage: new CookieStorage({ domain: `.${process.env.VUE_APP_HIREFUL_APP_DOMAIN}` })
        }
        const userPool = new CognitoUserPool(poolData)
        const cognitoUser = userPool.getCurrentUser()
        if (cognitoUser) {
          cognitoUser.signOut()
        }
      }
    },
    async getTokenForTechUser (account) {
      try {
        const withCredentialsConfig = {
          method: 'GET'
        }
        const techUserTokenResp = await axios(`${process.env.VUE_APP_LOGIN_API_HOST}${store.state.routes.getAccountTokenForTechUser}/${account}/token`, withCredentialsConfig)
        return techUserTokenResp.data
      } catch (error) {
        return false
      }
    },
    getCompanyTypeText (type) {
      switch (type) {
        case 'ATS':
          return 'ATS'

        case 'AGENCY':
          return 'Agency ATS'

        default:
          return false
      }
    },
    async getDevice () {
      try {
        const withCredentialsConfig = {
          method: 'GET'
        }
        const techUserTokenResp = await axios(`${process.env.VUE_APP_LOGIN_API_HOST}${store.state.routes.deviceDetection}`, withCredentialsConfig)
        if (techUserTokenResp.status === 200) {
          return techUserTokenResp.data.data.Values
        }
        return false
      } catch (error) {
        return false
      }
    }
  }
}
